import {useEffect, useState} from 'react';
import { Container } from "@mui/material";
import Calendar from "../../componentes/Calendario/CompCalendar";
import AdsService from "../../services/EspolAdsService";
import { CalendarData, CalendarEvent, listDataToListEvent } from '../../interfaces/EspolAds/CalendarData';
import '../../componentes/styles/calendar.css';

const adsService = new AdsService();

export const CalendarPage:React.FC<{}> = () => {
    let [calendario,setCalendario] = useState<Array<CalendarData>>([]);
    let [event,setEvent] = useState<Array<CalendarEvent>>([]);
    
    //#region function 
    async function calendarUnidad(id:number){
        await adsService.GetCalendarService(id)
               .then((data) => {                
                setCalendario(data);
                setEvent(listDataToListEvent(data));
                //console.log(calendario);
                //console.log(event);
                })               
               .catch((error) => console.error(error)); 
    }
    //#endregion
    useEffect(() => {
        calendarUnidad(142);
        },[]);
    
    return(
     <Container sx={{mt:2}}>
        <Calendar anuncios={calendario} events={event}/>
     </Container>
    );
}